/* global newrelic */
import { setState, getState } from '../analytics-state';

export const dataSources = () => {

  let lifeCycleConfirmed = false;
  
  const handleDataSources = ({ output } = {}) => {   
    const { variables, data, type } = output || {};
    if (type === 'product' && data?.product?.__typename === 'BaseProduct') {
      const { itemId, storeId, isBrandPricingPolicyCompliant = false } = variables || {};
      const originalState = getState();
      const pageItemId = originalState?.pageItemId || window.location?.pathname?.split('/')?.pop();
      if (data?.product?.itemId && data?.product?.itemId === pageItemId) {
        const updatedDataSources = {
          ...originalState?.dataSources,
          product: {
            ...originalState?.dataSources?.product,
            [data?.product?.itemId]: {
              ...originalState?.dataSources?.product?.[itemId],
              ...data?.product
            }
          }
        };
        setState({
          ...getState(),
          dataSources: updatedDataSources,
          storeId: storeId || originalState.storeId,
          pageItemId,
          isBrandPricingPolicyCompliant
        });
      }
    }
    if (type === 'product' && data?.serviceAddOns?.__typename === 'ServiceAddonsResponse') {
      const originalState = getState();
      if (variables?.itemId && variables?.itemId === originalState?.pageItemId) {
        const updatedDataSourcesAddOns = {
          ...originalState?.dataSources,
          product: {
            ...originalState?.dataSources?.product,
            [variables?.itemId]: {
              ...originalState?.dataSources?.product?.[variables?.itemId],
              serviceAddOns: data?.serviceAddOns,
            }
          }
        };
        setState({
          ...getState(),
          dataSources: updatedDataSourcesAddOns
        });
      }
    }
    if (data?.collection?.__typename === 'CollectionResponse') {
      const originalState = getState();
      if (variables?.collectionId) {
        const updatedDataSourcesCollection = {
          ...originalState?.dataSources,
          collection: {
            ...data?.collection,
            collectionId: variables?.collectionId
          }
        };
        setState({
          ...getState(),
          dataSources: updatedDataSourcesCollection
        });
      }
    }
  };

  const primaryHandler = ( event ) => {

    if ( lifeCycleConfirmed ) return;

    handleDataSources(event);
  };

  const lifeCycleHandler = ( event ) => {

    if ( !lifeCycleConfirmed ) {

      if ( typeof window.top._aape !== 'undefined' ) { 

        window.top._aape.dataSourceLifeCycleEnabled = true;

      } 

      lifeCycleConfirmed = true;
      window.LIFE_CYCLE_EVENT_BUS.off('data-sources.data', primaryHandler);

    }
    
    handleDataSources(event);
  };

  window.LIFE_CYCLE_EVENT_BUS.on('data-sources.data', primaryHandler);
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('data-sources.data', lifeCycleHandler);
};
